// import logo from './logo.svg';
import {Routes,Route, Navigate, useNavigate, }from 'react-router-dom'
import { useState } from 'react'
//import MainLayout from './layouts/MainLayout'
 import './App.css';

import Content from './components/login/Content'
import Login from  './components/login/Login'
import Header from './components/headernew/header'
import Menu from './components/menu/menu'
import MenuSibar from './components/menu-sibar/MenuSibar'

import Overview from './components/overview/overview'
import OverviewDashboard  from './components/overview/OverviewDashboard'
import ManagerUser from './components/manage/manager'
import Groupuser from './components/groupuser/groupuser'
import Role from './components/roles/role'
import RoleManager from './components/role-management/RoleManager'
import RoleManagerGroup from './components/role-management/RoleManagerGroup'
import CategoryList from './components/loaidanhmuc/CategoryList'
import Typecategogy from './components/loaidanhmuc/typecategogy'
import Data from './components/dulieu/data'
import Diarysystem from './components/nhatkyhethong/diarysystem'
import DairyAction from './components/nhatkyhethong/DairyAction'
import Backup from './components/saoluudulieu/backup'
import Restore from './components/khoi-phuc-du-lieu/restore'
import Newbackup from './components/sao-luu-moi/newbackup';
import Systemintegration from './components/tich-hop-he-thong/systemintegration'; 
import AddIntegration from './components/tich-hop-he-thong/AddIntegration'
import SetupSystem from './components/cau-hinh-he-thong/SetupSystem'
import SetupSecurity from './components/cau-hinh-he-thong/SetupSecurity'
import SetupEmail from './components/cau-hinh-he-thong/SetupEmail'
import SetupDisplay from './components/cau-hinh-he-thong/SetupDisplay'
import SetupOther from './components/cau-hinh-he-thong/SetupOther'
import Report from './components/bao-cao/report' 
import Footer from './components/footer/footer'

// Import nghiệp vụ mới

// import KhuCongNghiep from './components/khu-cong-nghiep/KhuCongNghiep';
// import DoanhNghiep from './components/doanh-nghiep/DoanhNghiep';
// import DauTu from './components/dau-tu-invest/DauTu';
// import DatDaiLand from './components/dat-dai-land/DatDaiLand';

import CongNghiep from './components/congnghiep/CongNghiep'
import DienLuc from './components/dienluc/DienLuc'
import ThuongMai from './components/thuongmai/ThuongMai'

// Ngành
import LinhVucNganh from './components/quan-ly-linh-vuc-nganh/LinhVucNganh'
import NhomLinhVuc from './components/quan-ly-linh-vuc-nganh/NhomLinhVuc'
import DanhMucLinhVuc from './components/quan-ly-linh-vuc-nganh/DanhMucLinhVuc'
import ThemLinhVuc from './components/quan-ly-linh-vuc-nganh/ThemLinhVuc'



function App() {
  const navigate   = useNavigate()

  const [isLogin, setIsLogin] = useState(false)

  // Hàm đăng nhập
  const handleLogin = () => {
    setIsLogin(true)
    navigate('/dashboard');
  }

  // Nếu chưa login => hiện màn hình login
  if (!isLogin) {
    return (
      <Login handleLogin={handleLogin} />
    )
  }
  return (
    <div className="App">
      {/* Heder */}
      <div className='row'>
        <Header/>
      </div>

      <div className='row g-0'>
        <div className='col-sm-2'>
            <MenuSibar/>
        </div>

        <div className='col-sm-10 offset-sm-2'>
          <Routes>
            {/* Tổng quan */}
            <Route   path='/dashboard' element={< OverviewDashboard/>}/>

            
            {/* <Route path='/khu-cong-nghiep' element={<KhuCongNghiep/>}/>

            
            <Route path='/doanh-nghiep' element={<DoanhNghiep/>}/>

            
            <Route path='/dau-tu-invest' element={<DauTu/>}/>

            
            <Route path='/dat-dai-land' element={<DatDaiLand/>}/> */}

            {/* Congnghiep */}
            <Route path='/congnghiep' element={<CongNghiep/>}/>

            {/* DienLuc */}
            <Route path='/dienluc' element={<DienLuc/>}/>

            {/* ThuongMai */}
            <Route path='/thuongmai' element={<ThuongMai/>}/>


              {/* Quản lý lĩnh vực ngành */}

              <Route path='/them-linh-vuc' element={<ThemLinhVuc/>}/>

              <Route path='/linh-vuc-nganh' element={<LinhVucNganh/>}/>

              <Route path='/nhom-linh-vuc' element={<NhomLinhVuc/>}/>

              <Route path='/danh-muc-linh-vuc' element={<DanhMucLinhVuc/>}/>

            {/* Người dùng */}
            <Route path='/list-user' element={<ManagerUser/>}/>

            {/* Nhóm người dùng */}
               <Route path='/group-users' element={<Groupuser/>}/>

            {/* Phân quyền theo nhóm  */}
             <Route path='/role-groups' element={<RoleManagerGroup/>}/>

             {/* Phân quyền theo người dùng */}
            <Route path='/role-user' element={<Role/>}/>

            {/*Quản lý vai trò =-> Danh sách vai trò */}
            <Route path='/list-roles' element={<RoleManager/>}/>

            {/* Danh mục dùng chung */}
            <Route path='/list-categogy' element={<CategoryList/>}/>
            <Route path='/type-categogy' element={<Typecategogy/>}/>

            {/* Quản lý dữ liệu */}
            <Route path='/manager-database' element={<Data/>}/>
            {/* <Route path='/dairy-database' element={<Typecategogy/>}/> */}

            {/* Tích hợp hệ thống */}
            <Route path='/list-integration' element={<Systemintegration/>}/>
            <Route path='/add-integration' element={<AddIntegration/>}/>

            {/* Nhật ký kệ thống */}
             <Route path='/login-dairy' element={<Systemintegration/>}/>
            <Route path='/data-dairy' element={<Diarysystem/>}/>
             <Route path='/action-dairy' element={<DairyAction/>}/>

             {/* Sao lưu dữ liệu */}
              <Route path='/list-backup' element={<Backup/>}/>
             <Route path='/new-backup' element={<Newbackup/>}/>
             <Route path='/restore-data' element={<Restore/>}/>
            {/* <Route path="/add-role" element={<Report />} /> */}

            {/* Cấu hình hệ thống */}
            <Route path='/noti-share' element={<SetupSystem/>}/>
            <Route path='/config-securyti' element={<SetupSecurity/>}/>
             <Route path='/config-email' element={<SetupEmail/>}/>
              <Route path='/config-show' element={<SetupDisplay/>}/>
             <Route path='/config-other' element={<SetupOther/>}/>

             {/* Báo cáo */}
              <Route path='/reports' element={<Report/>}/>
          </Routes>
          {/* <OverviewDashboard/> */}
            {/* <DairyAction/> */}
            {/* <CategoryList/> */}
            {/* <AddIntegration/> */}
        </div>

      </div>
    
      {/* footer */}
      <div>
        <Footer/>
      </div>
      
    </div>
  );
}

export default App;
